import { useState } from "react";

export const useLaboratoryState = () => {
  const [selectedAnalyte, setSelectedAnalyte] = useState<string | null>(null);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [isAddingExam, setIsAddingExam] = useState(false);
  const [addingAnalyteName, setAddingAnalyteName] = useState<string | null>(
    null
  );
  const [selectedExam, setSelectedExam] = useState<number | null>(null);
  const [isExtracting, setIsExtracting] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [inputKey, setInputKey] = useState(0);

  const resetStates = () => {
    setIsAddingExam(false);
    setAddingAnalyteName(null);
    setIsSubmitting(false);
  };

  const incrementInputKey = () => setInputKey((prev) => prev + 1);

  return {
    // States
    selectedAnalyte,
    editingIndex,
    isAddingExam,
    addingAnalyteName,
    selectedExam,
    isExtracting,
    isSubmitting,
    inputKey,

    // Setters
    setSelectedAnalyte,
    setEditingIndex,
    setIsAddingExam,
    setAddingAnalyteName,
    setSelectedExam,
    setIsExtracting,
    setIsSubmitting,

    // Actions
    resetStates,
    incrementInputKey,
  };
};
